module.exports = __webpack_public_path__ + "img/logo@3x.209ff76b.png";